/**
 * Legal & Trademark Configuration
 * Centralized settings and helper functions for branding and legal text.
 */

export interface LegalConfig {
  brandName: string;
  trademarkStatus: 'TM' | 'R';
  showPatentPending: boolean;
  legalOwner: string;
  brandWithMark: () => string;
  legalYear: () => number;
  legalLine: () => string;
  exportWatermark: (orgName?: string) => string;
}

export const legalConfig: LegalConfig = {
  brandName: 'StageFlow',
  trademarkStatus: 'TM', // 'TM' for trademark, 'R' for registered trademark
  showPatentPending: false,
  legalOwner: 'Digital Visionworks LLC',
  brandWithMark: () => {
    const symbol = legalConfig.trademarkStatus === 'R' ? '®' : '™';
    return `${legalConfig.brandName}${symbol}`;
  },
  legalYear: () => new Date().getFullYear(),
  legalLine: () => {
    let line = `© ${legalConfig.legalYear()} ${legalConfig.legalOwner}. All rights reserved. ${legalConfig.brandWithMark()} and the ${legalConfig.brandName} logo are trademarks of ${legalConfig.legalOwner}.`;
    if (legalConfig.showPatentPending) {
      line += ' Patent pending.';
    }
    return line;
  },
  exportWatermark: (orgName: string = 'Default Org') => {
    const timestamp = new Date().toISOString();
    return `Generated by ${legalConfig.brandWithMark()} — stageflowlive.com — Org: ${orgName} — ${timestamp}`;
  },
};

